// (A) 중립 Divider API — antd 미접촉. (B) PlainDivider 에 위임(순수 시각, 라이브러리 불필요).
import type { CSSProperties, ReactNode } from 'react'
import { PlainDivider } from '../_impl/PlainDivider'

export interface OmwDividerProps {
  /** 실측: TextFinder 가 vertical 사용. */
  type?: 'horizontal' | 'vertical'
  className?: string
  style?: CSSProperties
  children?: ReactNode
}

export function OmwDivider(props: OmwDividerProps) {
  return <PlainDivider {...props} />
}
